/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  VerifyURLRequestBody,
  VerifyURLRequestBody$Outbound,
  VerifyURLRequestBody$outboundSchema,
} from "../components/verifyurlrequestbody.js";

export type VerifyUserSessionIssuerCimdClientURLSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type VerifyUserSessionIssuerCimdClientURLSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type VerifyUserSessionIssuerCimdClientURLSecurity = {
  option1?: VerifyUserSessionIssuerCimdClientURLSecurityOption1 | undefined;
  option2?: VerifyUserSessionIssuerCimdClientURLSecurityOption2 | undefined;
};

export type VerifyUserSessionIssuerCimdClientURLRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  verifyURLRequestBody: VerifyURLRequestBody;
};

/** @internal */
export type VerifyUserSessionIssuerCimdClientURLSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const VerifyUserSessionIssuerCimdClientURLSecurityOption1$outboundSchema:
  z.ZodMiniType<
    VerifyUserSessionIssuerCimdClientURLSecurityOption1$Outbound,
    VerifyUserSessionIssuerCimdClientURLSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function verifyUserSessionIssuerCimdClientURLSecurityOption1ToJSON(
  verifyUserSessionIssuerCimdClientURLSecurityOption1:
    VerifyUserSessionIssuerCimdClientURLSecurityOption1,
): string {
  return JSON.stringify(
    VerifyUserSessionIssuerCimdClientURLSecurityOption1$outboundSchema.parse(
      verifyUserSessionIssuerCimdClientURLSecurityOption1,
    ),
  );
}

/** @internal */
export type VerifyUserSessionIssuerCimdClientURLSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const VerifyUserSessionIssuerCimdClientURLSecurityOption2$outboundSchema:
  z.ZodMiniType<
    VerifyUserSessionIssuerCimdClientURLSecurityOption2$Outbound,
    VerifyUserSessionIssuerCimdClientURLSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function verifyUserSessionIssuerCimdClientURLSecurityOption2ToJSON(
  verifyUserSessionIssuerCimdClientURLSecurityOption2:
    VerifyUserSessionIssuerCimdClientURLSecurityOption2,
): string {
  return JSON.stringify(
    VerifyUserSessionIssuerCimdClientURLSecurityOption2$outboundSchema.parse(
      verifyUserSessionIssuerCimdClientURLSecurityOption2,
    ),
  );
}

/** @internal */
export type VerifyUserSessionIssuerCimdClientURLSecurity$Outbound = {
  Option1?:
    | VerifyUserSessionIssuerCimdClientURLSecurityOption1$Outbound
    | undefined;
  Option2?:
    | VerifyUserSessionIssuerCimdClientURLSecurityOption2$Outbound
    | undefined;
};

/** @internal */
export const VerifyUserSessionIssuerCimdClientURLSecurity$outboundSchema:
  z.ZodMiniType<
    VerifyUserSessionIssuerCimdClientURLSecurity$Outbound,
    VerifyUserSessionIssuerCimdClientURLSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        VerifyUserSessionIssuerCimdClientURLSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        VerifyUserSessionIssuerCimdClientURLSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function verifyUserSessionIssuerCimdClientURLSecurityToJSON(
  verifyUserSessionIssuerCimdClientURLSecurity:
    VerifyUserSessionIssuerCimdClientURLSecurity,
): string {
  return JSON.stringify(
    VerifyUserSessionIssuerCimdClientURLSecurity$outboundSchema.parse(
      verifyUserSessionIssuerCimdClientURLSecurity,
    ),
  );
}

/** @internal */
export type VerifyUserSessionIssuerCimdClientURLRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  VerifyURLRequestBody: VerifyURLRequestBody$Outbound;
};

/** @internal */
export const VerifyUserSessionIssuerCimdClientURLRequest$outboundSchema:
  z.ZodMiniType<
    VerifyUserSessionIssuerCimdClientURLRequest$Outbound,
    VerifyUserSessionIssuerCimdClientURLRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
      verifyURLRequestBody: VerifyURLRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
        verifyURLRequestBody: "VerifyURLRequestBody",
      });
    }),
  );

export function verifyUserSessionIssuerCimdClientURLRequestToJSON(
  verifyUserSessionIssuerCimdClientURLRequest:
    VerifyUserSessionIssuerCimdClientURLRequest,
): string {
  return JSON.stringify(
    VerifyUserSessionIssuerCimdClientURLRequest$outboundSchema.parse(
      verifyUserSessionIssuerCimdClientURLRequest,
    ),
  );
}
